import { useTranslation } from 'react-i18next';

import styles from './ChartFooter.module.scss';

export const ChartFooter = () => {
  const { t } = useTranslation(['common', 'earnings']);

  return (
    <div className={styles.chartFooterRoot}>
      <div className={styles.footerItem}>{t('earnings:chart.helpText')}</div>
    </div>
  );
};
